import Nav from './Nav';
import Home from './Home';
import './index.css';

function Buyer(){
    return (
        <>
            <div className="main-farmer-page">
                <Nav />
                <Home />
            </div>
        </>
    )
}

export default Buyer;